import React from "react";
import styles from "./Button.module.scss";
import {ButtonPropsInterface} from "./Button.props.interface";

const Button: React.FC<ButtonPropsInterface> = (
    {
        children = undefined,
        size = 'medium',
        type = 'primary',
        theme = 'default',
        fill = false,
        disabled = false,
        isActive = false,
        onClick,
        htmlType,
        ...rest
    }) => {

    return <button
        {...rest}
        type={htmlType}
        disabled={disabled}
        onClick={onClick ? onClick : null}
        className={[
            styles.container,
            styles[size] || styles.medium,
            styles[type] || styles.primary,
            styles[theme] || styles.default,
            rest.className,
            fill ? styles.fill : null,
            isActive && styles.active,
        ].filter(x => x ?? x).join(' ')}>
        {children}
    </button>;
};

export default Button;
